function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import Base from "../Base/Base";
import Icon from "../Icon/Icon";
import "./AlertIcon.css";
export const ALERT_ICON_NAME_MAP = {
  error: "warning",
  info: "information",
  success: "tick",
  warning: "warning"
};
const SIZE_MAP = {
  tiny: "0.75rem",
  small: "1rem",
  medium: "2rem",
  large: "3rem"
};
export default class AlertIcon extends Component {
  render() {
    const {
      className,
      size,
      style,
      type,
      ...rest
    } = this.props;
    const classes = classnames(className, "ax-alert-icon", `ax-alert-icon--${style}`, `ax-alert-icon--${size}`, `ax-alert-icon--${type}`);
    return /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
      className: classes
    }), /*#__PURE__*/React.createElement(Icon, {
      name: ALERT_ICON_NAME_MAP[type],
      size: SIZE_MAP[size]
    }));
  }

}

_defineProperty(AlertIcon, "defaultProps", {
  size: "small",
  style: "primary",
  type: "info"
});